module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C593"
  }, [_c('span', {
    staticClass: "size_145"
  }, [_c('span', {
    staticClass: "color_0B0E11"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_3"
    }
  }, [_vm._v("Space")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C580"
  }, [_vm._v("Empty space is beautiful. It adds an element of calm and elegance to your design. It gives your eye a place to rest. Space, in design terms, is often called negative space or white space. But it doesn’t have to be white. Adding space to a quilt design gives the various elements of the quilt a chance to be seen and appreciated—otherwise the design is just too noisy. By controlling space, you are able to create rhythm and relationships.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C580"
  }, [_c('em', [_vm._v("Seedpod")]), _vm._v(" uses “windows,” which give the quilt space to breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "C572"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "img/14_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C694"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Seedpod ("), _c('span', {
    attrs: {
      "href": "#/xhtml/32_Seedpod_#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 106")]), _vm._v("), detail")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aac070e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Space.vue
// module id = 78
// module chunks = 0